import React, { useEffect, useState } from 'react';
import { Grid, TextField, Typography, FormControlLabel, Checkbox, Paper, MenuItem } from '@material-ui/core';
import { PARENTESCOS_BIENESTAR, INTERESADO_BIENESTAR } from '../../../helper';
import { useTheme } from '@material-ui/core/styles';
import { cargarCatalogo } from '../../components/CargarCatalogoBienestar';
import { useFormValidation } from './useFormValidation';

const PasoDatosGenerales = ({ state, onChange, onError, pintarSelect, solicitud }) => {
    const theme = useTheme();
    const { safeValue, safeError, conError } = useFormValidation(state);
    const esMenor = safeValue('es_menor_edad') === 'SI';
    const [parentesco_representante, setParentesco_representante] = useState([]);
    const [interesado, setInteresado] = useState([]);

    useEffect(() => {

            if (!state?.es_menor_edad || !state.es_menor_edad.valor) {
                onChange({
                    target: {
                        name: 'es_menor_edad',
                        value: 'NO'
                    }
                });
            }
    
            if (solicitud?.usuario_registro) {
    
                const usuario = solicitud.usuario_registro;
    
                const nombreCompleto = `
                    ${usuario.primer_nombre || ''} 
                    ${usuario.segundo_nombre || ''} 
                    ${usuario.primer_apellido || ''} 
                    ${usuario.segundo_apellido || ''}
                `.replace(/\s+/g, ' ').trim();
    
                onChange({
                    target: {
                        name: 'nombre_completo',
                        value: nombreCompleto
                    }
                });
    
                onChange({
                    target: {
                        name: 'documento_identidad',
                        value: usuario.identificacion || ''
                    }
                });
    
                onChange({
                    target: {
                        name: 'numero_contacto',
                        value: usuario.celular || usuario.telefono || ''
                    }
                });
            }
    
            const cargarTodo = async () => {
                await Promise.all([
                    cargarCatalogo(INTERESADO_BIENESTAR, setInteresado),
                    cargarCatalogo(PARENTESCOS_BIENESTAR, setParentesco_representante),
                ]);
            };
            cargarTodo();
    
        }, [solicitud]);

    return (
        <Grid container spacing={3}>
            {/* SECCIÓN 1: DATOS BÁSICOS */}
            <Grid item xs={12} md={6}>
                <TextField
                    disabled
                    fullWidth
                    label="Nombre Completo"
                    name="nombre_completo"
                    value={safeValue('nombre_completo')}
                    onChange={onChange}
                    error={conError(safeError('nombre_completo'))}
                    helperText={safeError('nombre_completo')}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <TextField
                    disabled
                    fullWidth
                    label="No. de Documento"
                    name="documento_identidad"
                    value={safeValue('documento_identidad')}
                    onChange={onChange}
                    error={conError(safeError('documento_identidad'))}
                    helperText={safeError('documento_identidad')}
                />
            </Grid>
            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    label="Lugar de Expedición"
                    name="lugar_expedicion"
                    value={safeValue('lugar_expedicion')}
                    onChange={onChange}
                    error={conError(safeError('lugar_expedicion'))}
                    helperText={safeError('lugar_expedicion')}
                />
            </Grid>
            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    select
                    label="calidad Entrevistado"
                    name="calidad_entrevistado"
                    value={safeValue('calidad_entrevistado')}
                    onChange={onChange}
                    error={conError(safeError('calidad_entrevistado'))}
                    helperText={safeError('calidad_entrevistado')}
                    >
                    {interesado.map((opcion) => (
                    <MenuItem key={opcion.value} value={opcion.label}>
                        {opcion.label}
                    </MenuItem>
                    ))}
                </TextField>
            </Grid>
            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    label="Número de contacto"
                    name="numero_contacto"
                    value={safeValue('numero_contacto')}
                    onChange={onChange}
                    error={conError(safeError('numero_contacto'))}
                    helperText={safeError('numero_contacto')}
                />
            </Grid>

            {/* CONTROL MENOR DE EDAD */}
            <Grid item xs={12}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={esMenor}
                            onChange={(e) => onChange({
                                target: {
                                    name: 'es_menor_edad',
                                    value: e.target.checked ? 'SI' : 'NO'
                                }
                            })}
                            color="primary"
                        />
                    }
                    label="¿El entrevistado es menor de edad?"
                />
            </Grid>

            {/* SECCIÓN DINÁMICA DE ACOMPAÑAMIENTO */}
            {esMenor ? (
                <>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="Representante de (Él/La) estudiante"
                            name="nombre_representante"
                            value={safeValue('nombre_representante')}
                            onChange={onChange}
                            error={conError(safeError('nombre_representante'))}
                            helperText={safeError('nombre_representante')}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="Parentesco"
                            name="parentesco_representante"
                            value={safeValue('parentesco_representante')}
                            onChange={onChange}
                            select
                            error={conError(safeError('parentesco_representante'))}
                            helperText={safeError('parentesco_representante')}
                        >
                            {parentesco_representante.map((opcion) => (
                                <MenuItem key={opcion.value} value={opcion.label}>
                                {opcion.label}
                                </MenuItem>
                            ))}
                        </TextField>

                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label="CC. Representante"
                            name="cc_representante"
                            value={safeValue('cc_representante')}
                            onChange={onChange}
                            error={conError(safeError('cc_representante'))}
                            helperText={safeError('cc_representante')}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label="Lugar de expedición"
                            name="expedicion_representante"
                            value={safeValue('expedicion_representante')}
                            onChange={onChange}
                            error={conError(safeError('expedicion_representante'))}
                            helperText={safeError('expedicion_representante')}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            label="Número de contacto"
                            name="contacto_representante"
                            value={safeValue('contacto_representante')}
                            onChange={onChange}
                            error={conError(safeError('contacto_representante'))}
                            helperText={safeError('contacto_representante')}
                        />
                    </Grid>
                </>
            ) : (
                <>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="Nombre de la persona autorizada"
                            name="nombre_autorizado"
                            value={safeValue('nombre_autorizado')}
                            onChange={onChange}
                            error={conError(safeError('nombre_autorizado'))}
                            helperText={safeError('nombre_autorizado')}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            label="Identificado con CC"
                            name="cc_autorizado"
                            value={safeValue('cc_autorizado')}
                            onChange={onChange}
                            error={conError(safeError('cc_autorizado'))}
                            helperText={safeError('cc_autorizado')}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            label="Número de contacto"
                            name="contacto_autorizado"
                            value={safeValue('contacto_autorizado')}
                            onChange={onChange}
                            error={conError(safeError('contacto_autorizado'))}
                            helperText={safeError('contacto_autorizado')}
                        />
                    </Grid>
                </>
            )}

            <Grid item xs={12}>
                <Paper elevation={0} style={{ padding: 15, backgroundColor: '#f9f9f9', borderLeft: `4px solid ${theme.palette.primary.main}`}}>
                    <Typography variant="caption" style={{ textAlign: 'justify', display: 'block' }}>
                        <b>Declaración:</b> Doy fe que se me ha explicado tanto el alcance como los límites del proceso 
                        que he iniciado con esta entrevista en el marco de la Ruta de Atención VBG.
                    </Typography>
                </Paper>
            </Grid>
        </Grid>
    );
};

export const Formulario003Steps = [
    {
        label: 'Datos de la Entrevista y Acompañamiento',
        render: (props) => <PasoDatosGenerales {...props} />
    }
];